import { PropAsset } from './PropAsset';

// Ruins / Broken Pillar - Yıkıntı / Kırık Sütun
// TODO: Replace with SVG asset
export class Ruins extends PropAsset {
  readonly id = 'ruins';
  readonly width = 85;
  readonly height = 70;
  readonly walkable = false;
  readonly collisionRadius = 0.8;
  readonly occludesPlayer = true;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 12 * s, 6 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Pillar base - Sütun tabanı
    ctx.fillStyle = '#7a7a6a';
    ctx.fillRect(cx - 10 * s, cy - 8 * s, 20 * s, 8 * s);

    // Main pillar body - Ana sütun gövdesi
    ctx.fillStyle = '#8a8a7a';
    ctx.fillRect(cx - 8 * s, cy - 38 * s, 16 * s, 30 * s);

    // Broken top - Kırık üst
    ctx.fillStyle = '#7a7a6a';
    ctx.beginPath();
    ctx.moveTo(cx - 8 * s, cy - 38 * s);
    ctx.lineTo(cx - 5 * s, cy - 45 * s);
    ctx.lineTo(cx + 2 * s, cy - 40 * s);
    ctx.lineTo(cx + 8 * s, cy - 38 * s);
    ctx.closePath();
    ctx.fill();

    // Cracks - Çatlaklar
    ctx.strokeStyle = '#5a5a4a';
    ctx.lineWidth = 1 * s;
    ctx.beginPath();
    ctx.moveTo(cx - 3 * s, cy - 35 * s);
    ctx.lineTo(cx - 1 * s, cy - 25 * s);
    ctx.lineTo(cx + 2 * s, cy - 15 * s);
    ctx.stroke();

    // Fallen piece (variant 0)
    if (variant === 0) {
      ctx.fillStyle = '#6a6a5a';
      ctx.beginPath();
      ctx.moveTo(cx + 12 * s, cy - 3 * s);
      ctx.lineTo(cx + 18 * s, cy - 8 * s);
      ctx.lineTo(cx + 22 * s, cy - 5 * s);
      ctx.lineTo(cx + 16 * s, cy - 2 * s);
      ctx.closePath();
      ctx.fill();
    }

    // Moss/vegetation - Yosun
    ctx.fillStyle = '#3a5a3a';
    ctx.beginPath();
    ctx.arc(cx - 6 * s, cy - 10 * s, 3 * s, 0, Math.PI * 2);
    ctx.arc(cx + 5 * s, cy - 6 * s, 2 * s, 0, Math.PI * 2);
    ctx.fill();
  }
}
